<div
  *ngIf="isLoading"
  class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/80"
>
  <mat-spinner diameter="48"></mat-spinner>
  <p class="mt-4 text-gray-600 text-sm">Processing payment, please wait…</p>
</div>

<div
  *ngIf="!isLoading && checkoutInfo?.transactionStatus"
  class="min-h-screen flex items-center justify-center px-4"
>
  <div class="w-full max-w-2xl bg-white border border-gray-200 rounded-xl shadow-md p-6 sm:p-8">
    <div class="flex flex-col sm:flex-row gap-6 items-center sm:items-start">
      <mat-icon
        class="text-6xl"
        [ngClass]="{
          'text-green-600': isCompleted,
          'text-yellow-500': isPending,
          'text-red-600': isFailed,
        }"
      >
        {{ isCompleted ? 'check_circle' : isPending ? 'hourglass_top' : 'error' }}
      </mat-icon>

      <div class="flex-1 text-center sm:text-left space-y-2">
        <h2 class="text-2xl font-semibold text-gray-800">
          {{ statusTitle }}
        </h2>

        <p class="text-sm text-gray-600">
          Amount:
          <span class="font-medium text-gray-900">
            {{ checkoutInfo.currency.symbol }} {{ checkoutInfo.amount }}
          </span>
        </p>

        <p class="text-sm text-gray-600 break-all">
          Invoice No:
          <span class="font-mono font-medium text-gray-900">
            {{ checkoutInfo.invoiceNumber }}
          </span>
        </p>
        <div
          *ngIf="checkoutInfo.errorDescription"
          class="mt-3 p-3 rounded-md bg-red-50 border border-red-200 text-sm text-red-700"
        >
          {{ checkoutInfo.errorDescription }}
        </div>
      </div>
    </div>

    <div class="mt-8 flex justify-end">
      <a
        *ngIf="isCompleted"
        target="_top"
        [href]="
          checkoutInfo.callBackUrl +
          '?refNo=' +
          checkoutInfo.invoiceNumber +
          '&paymentChannel=' +
          checkoutInfo.paymentChannel
        "
        class="inline-flex items-center justify-center rounded-md bg-purple-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-purple-700 transition"
      >
        Continue
      </a>

      <a
        *ngIf="isFailed"
        target="_top"
        [href]="
          checkoutInfo.callBackUrl +
          '?refNo=' +
          checkoutInfo.invoiceNumber +
          '&paymentChannel=' +
          checkoutInfo.paymentChannel
        "
        class="inline-flex items-center justify-center rounded-md bg-red-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-red-700 transition"
      >
        Try Again
      </a>
    </div>
  </div>
</div>
